const isString = require('lodash.isstring');
const merge = require('lodash.merge');
const imagesLoaded = require('imagesloaded');
const ajax = require('./ajax');
const util = require('./util');

const dialog = {
    /**
     * @function
     * @description Appends a dialog to a given container (target)
     * @param {Object} params  params.target can be an id selector or an jquery object
     */
    create(params) {
        let $target; let
            id;

        if (!this.exists()) {
            this.uiEvents();
        }

        if (isString(params.target)) {
            if (params.target.charAt(0) === '#') {
                $target = $(params.target);
            } else {
                $target = $(`#${params.target}`);
            }
        } else if (params.target instanceof jQuery) {
            $target = params.target;
        } else {
            $target = $('#dialog-container');
        }

        // if no element found, create one
        if ($target.length === 0) {
            if ($target.selector && $target.selector.charAt(0) === '#') {
                id = $target.selector.substr(1);
                $target = $('<div>').attr('id', id).addClass('dialog-content').appendTo('body');
            }
        }

        // create the dialog
        this.$container = $target;
        this.$container.dialog(merge({}, this.settings, params.options || {}));
    },
    /**
     * @function
     * @description Opens a dialog using the given url (params.url) or html (params.html)
     * @param {Object} params
     * @param {Object} params.url should contain the url
     * @param {String} params.html contains the html of the dialog content
     */
    open(params) {
        // close any open dialog
        if (params.doClose === false) {
            // Do nothing so that the fallback is to always close it
        } else {
            this.close();
        }
        this.create(params);
        this.replace(params);
        $('#wrapper').attr('aria-hidden', 'true');
        $(document).on('click', '.ui-widget-overlay', (e) => {
            e.stopImmediatePropagation();
            const currentDialog = $('div:ui-dialog:visible').length - 1;
            $($('div:ui-dialog:visible')[currentDialog]).dialog('close');
        });
    },
    /**
     * @description populate the dialog with html content, then open it
     * */
    openWithContent(params) {
        let position;

        if (!this.$container) { return; }
        const content = params.content || params.html;
        if (!content) { return; }

        // Prevent exception in third-party tags that prevent dialog from opening
        if (window.googletag && !window.googletag.cmd) {
            window.googletag.cmd = [];
        }

        this.$container.empty().html(content);
        if (!this.$container.dialog('isOpen')) {
            this.$container.dialog('open');
        }

        if (params.options) {
            position = params.options.position;
        }
        if (!position) {
            position = this.settings.position;
        }
        imagesLoaded(this.$container).on('done', () => {
            this.$container.dialog('option', 'position', position);
        });

        $('.ui-dialog .ui-dialog-titlebar').focus();

        const callback = (typeof params.callback === 'function') ? params.callback : function emptyCallback() {};
        callback();
        $(document).on('click', '.ui-widget-overlay', (e) => {
            e.stopImmediatePropagation();
            const currentDialog = $('div:ui-dialog:visible').length - 1;
            $($('div:ui-dialog:visible')[currentDialog]).dialog('close');
        });
    },
    /**
     * @description Replace the content of current dialog
     * @param {object} params
     * @param {string} params.url - If the url property is provided, an ajax call is performed to get the content to replace
     * @param {string} params.html - If no url property is provided, use html provided to replace
     */
    replace(params) {
        if (!this.$container) {
            return;
        }
        if (params.url) {
            // eslint-disable-next-line
            params.url = util.appendParamToURL(params.url, 'format', 'ajax');
            ajax.load({
                url: params.url,
                data: params.data,
                callback: function loadCallback(response) {
                    // eslint-disable-next-line
                    params.content = response;
                    this.openWithContent(params);
                }.bind(this),
            });
        } else if (params.html) {
            this.openWithContent(params);
        }
    },
    /**
     * @function
     * @description Closes the dialog
     */
    close() {
        if (!this.$container) {
            return;
        }
        this.$container.dialog('close');
    },
    exists() {
        return this.$container && (this.$container.length > 0);
    },
    isActive() {
        return this.exists() && (this.$container.children.length > 0);
    },
    updateOption($attrib, $value) {
        if (this.$container) {
            this.$container.dialog('option', $attrib, $value);
        }
    },
    hasActiveContainer() {
        if (typeof this.$container !== 'undefined' && this.$container.length > 0) {
            return true;
        }
        return false;
    },
    uiEvents() {
        const self = this;

        // Update dialog modal position on resize event
        $(window).off('resize.dialog-overlay');
        $(window).on('resize.dialog-overlay', () => {
            if (self.hasActiveContainer()) {
                const initialPosition = self.$container.dialog('option', 'position');
                self.updateOption('position', initialPosition);
            }
        });
    },
    settings: {
        autoOpen: false,
        height: 'auto',
        modal: true,
        overlay: {
            opacity: 0.5,
            background: 'black',
        },
        resizable: false,
        title: '',
        width: '800',
        close() {
            $(this).dialog('close');
            $('#wrapper').attr('aria-hidden', 'false');
            if ($('div:ui-dialog:visible').length === 0) {
                $(document).off('click', '.ui-widget-overlay');
            }
        },
        position: {
            my: 'center',
            at: 'center',
            of: window,
            collision: 'flipfit',
        },
    },
};

module.exports = dialog;
